import React, { useState, useEffect } from "react";
import firebase from "../../../firebase";
import "firebase/firestore";

import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Zoom from "@material-ui/core/Zoom";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import { green } from "@material-ui/core/colors";
import Box from "@material-ui/core/Box";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import NuevaEmpresa from "./nuevaEmpresa";
import NuevaCuenta from "./nuevaCuenta";

import EditarEmpresa from "./editarEmpresa";
import BorrarCuenta from "./borrarCuenta";
import BorrarEmpresa from "./borrarEmpresa";

const db = firebase.firestore();

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`action-tabpanel-${index}`}
      aria-labelledby={`action-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `action-tab-${index}`,
    "aria-controls": `action-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: "90%",
    marginTop: "2%",
    marginLeft: "5%",
    position: "relative",
    minHeight: "70vh",
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(10),
    right: theme.spacing(10),
  },
  fabGreen: {
    color: theme.palette.common.white,
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[600],
    },
  },
}));

const Dashboard = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const [usuarios, setUsuarios] = useState([]);
  const [empresas, setEmpresas] = useState([]);

  useEffect(() => {
    if (props.user.rol !== "superadmin") {
      db.collection("usuarios")
        .where("empresa", "in", [props.user.empresa])
        .onSnapshot(function (querySnapshot) {
          let documentos = [];
          querySnapshot.forEach((d) => {
            documentos.push({
              ...d.data(),
              id: d.id,
            });
          });
          setUsuarios(documentos);
        });
    } else {
      db.collection("usuarios").onSnapshot(function (querySnapshot) {
        let documentos = [];
        querySnapshot.forEach((d) => {
          documentos.push({
            ...d.data(),
            id: d.id,
          });
        });
        setUsuarios(documentos);
      });
    }

    db.collection("empresas").onSnapshot(function (querySnapshot) {
      let documentos = [];
      querySnapshot.forEach((d) => {
        documentos.push({
          ...d.data(),
          id: d.id,
        });
      });
      setEmpresas(documentos);
    });
  }, [props.user]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };

  const fabs = [
    {
      color: "primary",
      className: classes.fab,
      icon: <AddIcon />,
      label: "Add",
      onClick: () => {},
    },
    {
      color: "secondary",
      className: classes.fab,
      icon: <AddIcon />,
      label: "Edit",
      onClick: () => {},
    },
  ];

  return (
    <div className={classes.root}>
      {props.user && props.user.rol === "superadmin" && (
        <AppBar position="static" color="default">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="action tabs example"
          >
            <Tab label="Usuarios" {...a11yProps(0)} />
            <Tab label="Establecimientos" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
      )}
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <TableContainer>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Rol</TableCell>
                  <TableCell>Borrar</TableCell>
                  {props.user && props.user.rol === "superadmin" && (
                    <TableCell>Establecimiento</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {usuarios.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.name} </TableCell>
                    <TableCell>{row.email} </TableCell>
                    <TableCell>{row.rol} </TableCell>
                    {props.user && props.user.rol === "superadmin" && (
                      <TableCell>
                        {row.empresa
                          ? empresas.find((e) => e.id === row.empresa)
                            ? empresas.find((e) => e.id === row.empresa).name
                            : ""
                          : "-"}{" "}
                      </TableCell>
                    )}
                    <TableCell>
                      <BorrarCuenta usuario={row}>
                        <DeleteIcon />
                      </BorrarCuenta>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <TableContainer>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Editar</TableCell>
                  <TableCell>Borrar</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {empresas.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.name} </TableCell>
                    <TableCell>
                      <EditarEmpresa empresa={row}>
                        <EditIcon />
                      </EditarEmpresa>
                    </TableCell>
                    <TableCell>
                      <TableCell>
                        <BorrarEmpresa empresa={row}>
                          <DeleteIcon />
                        </BorrarEmpresa>
                      </TableCell>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>
      </SwipeableViews>
      {fabs.map((fab, index) =>
        index === 0 ? (
          <NuevaCuenta user={props.user} empresas={empresas}>
            <Zoom
              key={fab.color}
              in={value === index}
              timeout={transitionDuration}
              style={{
                transitionDelay: `${
                  value === index ? transitionDuration.exit : 0
                }ms`,
              }}
              unmountOnExit
            >
              <Fab
                aria-label={fab.label}
                className={fab.className}
                color={fab.color}
                onClick={fab.onClick}
              >
                {fab.icon}
              </Fab>
            </Zoom>
          </NuevaCuenta>
        ) : (
          <NuevaEmpresa>
            <Zoom
              key={fab.color}
              in={value === index}
              timeout={transitionDuration}
              style={{
                transitionDelay: `${
                  value === index ? transitionDuration.exit : 0
                }ms`,
              }}
              unmountOnExit
            >
              <Fab
                aria-label={fab.label}
                className={fab.className}
                color={fab.color}
                onClick={fab.onClick}
              >
                {fab.icon}
              </Fab>
            </Zoom>
          </NuevaEmpresa>
        )
      )}
    </div>
  );
};

export default Dashboard;
